// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-20 {
  width: 20%;
}

.width-60 {
  width: 60%;
}

.app-header label {
  height: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 20px;
  text-align: center;
  color: #000000;
}
.app-header label span {
  color: #1ba192;
}
.app-header .navbar-toggler.d-lg-none {
  float: left;
  color: #1ba192;
}

@media all and (min-width: 992px) and (max-width: 1280px) {
  .app-header {
    display: none;
  }
}
@media only screen and (min-width: 64.063em) {
  .app-header {
    display: none;
  }
}
@media only screen and (min-width: 64.063em) and (max-width: 90em) {
  .app-header {
    display: none;
  }
}
@media only screen and (min-width: 90.063em) {
  .app-header {
    display: none;
  }
}
@media only screen and (min-width: 90.063em) and (max-width: 120em) {
  .app-header {
    display: none;
  }
}
@media only screen and (min-width: 120.063em) {
  .app-header {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/containers/components/app-header/app-header.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AACA;EACE,UAAA;AAEF;;AACE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAEJ;AADI;EACE,cAAA;AAGN;AAAE;EACE,WAAA;EACA,cAAA;AAEJ;;AACA;EACE;IACE,aAAA;EAEF;AACF;AAAA;EACE;IACE,aAAA;EAEF;AACF;AAAA;EACE;IACE,aAAA;EAEF;AACF;AAAA;EACE;IACE,aAAA;EAEF;AACF;AAAA;EACE;IACE,aAAA;EAEF;AACF;AAAA;EACE;IACE,aAAA;EAEF;AACF","sourcesContent":[".width-20 {\n  width: 20%;\n}\n.width-60 {\n  width: 60%;\n}\n.app-header {\n  label {\n    height: 20px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 21px;\n    line-height: 20px;\n    text-align: center;\n    color: #000000;\n    span {\n      color: #1ba192;\n    }\n  }\n  .navbar-toggler.d-lg-none {\n    float: left;\n    color: #1ba192;\n  }\n}\n@media all and (min-width: 992px) and (max-width: 1280px) {\n  .app-header {\n    display: none;\n  }\n}\n@media only screen and (min-width: 64.063em) {\n  .app-header {\n    display: none;\n  }\n}\n@media only screen and (min-width: 64.063em) and (max-width: 90em) {\n  .app-header {\n    display: none;\n  }\n}\n@media only screen and (min-width: 90.063em) {\n  .app-header {\n    display: none;\n  }\n}\n@media only screen and (min-width: 90.063em) and (max-width: 120em) {\n  .app-header {\n    display: none;\n  }\n}\n@media only screen and (min-width: 120.063em) {\n  .app-header {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
